import { env } from "@/app/utils/env";
import { type RootState, useAppSelector } from "@/redux/store";

/**
 * Checks whether the current user can access maintenance bypass-only routes.
 *
 * @returns Whether the current user email matches the configured maintenance bypass email.
 */
export const useMaintenanceBypassAccess = (): boolean => {
  const currentUserEmail = useAppSelector(
    (state: RootState) => state.user.userData?.email,
  );
  const allowedBypassEmail = env.MAINTENANCE_BYPASS_USER_EMAIL?.trim();

  return (
    Boolean(allowedBypassEmail) &&
    currentUserEmail?.toLowerCase() === allowedBypassEmail?.toLowerCase()
  );
};
